export default __webpack_public_path__ + "static/media/flowering-plants.ecc712aa.jpg";